import { createFileRoute } from '@tanstack/react-router';
import { EventsListPage } from '@pages/events';

/** Veranstaltungsliste-Route (/events) */
export const Route = createFileRoute('/_authenticated/events/')({
  component: EventsListPage,
});
